import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SelectItem } from 'primeng/api';
import { FormMode, Customerinvoices } from 'src/app/_models/models';
import { CustomerInvoicesService } from 'src/app/services/api/customer-invoices.service';
import { ClientsService } from 'src/app/services/api/clients.service';
import { RouterOutlet } from '@angular/router';
import { CarrierInvoiceFilesService } from 'src/app/services/api/carrier-invoice-files.service';
import { AlertMessage, AlertOptions, AlertService, AlertSeverity, AlertTypes } from 'src/app/alert/alert.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MAT_PAGINATOR_DEFAULT_OPTIONS, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonService } from 'src/app/services/common.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
//import { debug } from 'console';
// import * as internal from 'stream';



@Component({
  selector: 'app-invoicing-customer-invoice-index-component',
  templateUrl: './customer-invoices.component.html',
  styleUrls: ['./customer-invoices.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class InvoicingCustomerInvioceIndexComponent implements OnInit {

  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('callAddTransacationDialog') callAddTransacationDialog: TemplateRef<any>;
  CarrierInvoiceFileControllerUrl: string = "";
  _http: HttpClient;
  _baseUrl: string;
  public formListData: Customerinvoices[] = new Array<Customerinvoices>();
  public tabledata: Array<any> = [];
  disableAddTransaction: boolean = true;
  loadselected: any;
  Postaction: string = 'Pull';
  public mode: FormMode = FormMode.None;
  loadGridData = new BehaviorSubject(false);
  pageNumber: number = 0;
  pageSize: number = 5;
  pageNum: number = 0;
  pageSizee: number = 5;
  DisableState: boolean = false;
  public formModes = FormMode;
  MinDate: any;
  MaxDate: any;
  public model: Customerinvoices = new Customerinvoices();

  public showdiag: boolean = false;
  public diagmsg: string;
  public showTransactionDiag: boolean = false;

  clients: SelectItem[] = new Array<SelectItem>();
  clientsMaster: SelectItem[] = new Array<SelectItem>();
  carrierInvoices: SelectItem[] = new Array<SelectItem>();
  pageLength: number;
  pageLengthh: number;

  StatusOptions: SelectItem[] = [
    { label: "Created", value: "Created" },
    { label: "Finalized", value: "Finalized" },
    { label: "Sent", value: "Sent" },
    { label: "Paid", value: "Paid" },
    { label: "Deleted", value: "Deleted" }
  ];
  mindate: Date = new Date(2013, 1, 1);
  maxdate: Date = new Date(2037, 12, 31);
  displayedColumns: string[] = ['Client', 'Status', 'Date', 'Total', "..."];
  dataSource: MatTableDataSource<any>;
  data = [];
  dataMainPage: MatTableDataSource<any>;

  @ViewChild('Transactionpaginator', { static: false }) Transactionpaginator: MatPaginator;
  @ViewChild('TransactionMainPagepaginator', { static: false }) TransactionMainPagepaginator: MatPaginator;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  transactionColumns: string[] = ['select', 'Transaction Date', 'Tracking/Invoice number', 'Description of Charge', 'netAmount', 'incentiveAmount'];
  transactionColumnsMainPage: string[] = ['Transaction Date', 'Tracking/Invoice number', 'Description of Charge', 'netAmount', 'incentiveAmount'];

  TransactiondataSource: MatTableDataSource<any>;
  TransactiondataSourceMainPage: MatTableDataSource<any>;

  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.TransactiondataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.TransactiondataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;

  }

  ngAfterViewInit() {
  }

  constructor(private clientService: ClientsService, private customerInvoices: CustomerInvoicesService, private carrierInvoiceFiles: CarrierInvoiceFilesService, private alert: AlertService, private _snackBar: MatSnackBar,
    private snackservice: SnackBarService, private dialog: MatDialog, private comm: CommonService) {
    this.TransactiondataSource = new MatTableDataSource<any>([]);
    this.TransactiondataSourceMainPage = new MatTableDataSource<any>([]);
    this.CarrierInvoiceFileControllerUrl = comm.getApiAddress() + '/CustomerInvoices/Download';
  }

  ngOnInit() {
    this.customerInvoices.carrierInvoiceDatasource.next('');
    this.clientService.getAllClientMasters(null).subscribe(result => {
      result.forEach(e => {
        this.clients.push({ label: e.name, value: e.id });
      });
      this.loadListData(this.pageNumber, this.pageSize);
      //this.loadInvoiceFiles();
    }, error => {
      this.openSnackBar("There is an error while fetching the invoices " + error.error.message, "error")
    });
    //this.clientService.getAll(null).subscribe(result => {
    //  result.forEach(e => {
    //    this.clients.push({ label: e.name, value: e.id });
    //  });
    //  this.loadListData(this.pageNumber,this.pageSize);
    //  //this.loadInvoiceFiles();
    //}, error => {
    //  this.openSnackBar("There is an error while fetching the invoices " + error.error.message, "error")
    //});

    this.TransactiondataSourceMainPage.paginator = this.TransactionMainPagepaginator;

    this.loadGridData.subscribe((isTransactionsAdded) => {
      if (isTransactionsAdded) {
        this.loadGridDataInEdit(this.model, 'load');
      }
    });

  }

  public onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        this.customerInvoices.getAll(this.model.status, this.pageNum + 1,this.pageSizee).subscribe((result: any) => {
          this.formListData = new Array<Customerinvoices>();
          this.tabledata  = result.data;
          this.dataSource = new MatTableDataSource(this.tabledata);
          this.dataSource.paginator = this.paginator;
          this.pageLengthh = result.totalRecords;        
          result.forEach(e => {
            this.formListData.push({
              id: e?.id,
              total: e.total,
              status: e.status,
              invoiceDate: new Date(e.invoiceDate),
              //clientId: e.clientId,
              clientId: e.clientMasterId,
              //clientMasterId: e.clientMasterId,
              invoiceStartDate: e.invoiceStartDate,
              invoiceEndDate: e.invoiceEndDate,
              selected: false
            });
          });
        }, error => {
          //debugger;
          this.openSnackBar("Unable to fetch the Customer Invoices", 'error');
        });
        break;
      }
      case FormMode.New: {
        if (form.invalid) {

        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete();
        break;
      }
      default: {
        break;
      }
    }
  }

  public post(form: any) {
    //debugger;
    this.snackservice.loader();
    //debugger;
    let selectedDate = new Date(form.controls.InvoiceDate.value);
    let req = {
      ClientId: form.controls.ClientId.value,
      InvoiceDate: selectedDate.toLocaleString(),
      Status: form.controls.Status.value,
      Total: form.controls.Total.value,
      MinDate: this.model.invoiceStartDate ? this.model.invoiceStartDate : selectedDate.toLocaleString(),
      MaxDate: this.model.invoiceEndDate ? this.model.invoiceEndDate : selectedDate.toLocaleString()
    }
    this.customerInvoices.create(req).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData(this.pageNumber,this.pageSize);
      this.resetForm();
      setTimeout(() => {
        this.snackservice.CloseProgressSpinner(true);

      }, 300);
      this.openSnackBar('Customer Invoices Created sucessfully', 'success');
    }, error => function (ex) {

      setTimeout(() => {
        this.snackservice.CloseProgressSpinner(true);

      }, 300);
      this.openSnackBar(ex.status, 'error');
    });
  }

  public put(form: any) {
    // this.DisableState = this.model.status == 'Deleted'?true : false;
    var dateStr = this.model.invoiceDate;
    var days = 1;

    this.model.invoiceDate = new Date(new Date(dateStr).setDate(new Date(dateStr).getDate() + days));
    this.customerInvoices.update(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData(this.pageNumber,this.pageSize);
    }, error => {

      // alert('Error!');
      this.openSnackBar("Failed to update customer invoice", 'error');

    });
  }

  public delete() {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Delete Customer Invoice',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          message: 'Are you sure you want to DELETE selected Customer Invoice?',
          // alertcontent: '*you cannot undo the changes',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {

          this.customerInvoices.delete(this.model.id).subscribe(result => {
            this.resetForm();
            this.loadListData(this.pageNumber,this.pageSize);
            this.openSnackBar('Customer Invoices Deleted sucessfully', 'success');

          }, error => {

            this.openSnackBar('Failed to delete customer invoices', 'error');

          });

        }
      });

  }

  public showMessage(msg: string) {
    this.diagmsg = msg;
    this.showdiag = true;
  }

  public onDoagClose() {
    this.showdiag = false;
  }

  onPageEvent(event: PageEvent) {
    this.pageNum = event.pageIndex;
    this.pageSizee = event.pageSize;
    this.loadListData(this.pageNum, this.pageSizee);
  }

  public loadListData(pageNum, pageSizee) {
    this.customerInvoices.getAll(null, pageNum + 1, pageSizee).subscribe((result: any)=> {
      this.formListData = new Array<Customerinvoices>();
      this.tabledata = result.data;    
      this.dataSource = new MatTableDataSource(this.tabledata);
      this.dataSource.paginator = this.paginator;
      this.pageLengthh = result.totalRecords;
      console.log(this.pageLength);
      let p = { ...this.model };
      result.forEach(e => {
        this.formListData.push({
          id: e?.id,
          total: e.total,
          status: e.status,
          invoiceDate: e.invoiceDate,
          //clientId: e.clientId,
          clientId: e.clientMasterId,
          invoiceStartDate: e.invoiceStartDate,
          invoiceEndDate: e.invoiceEndDate,
          selected: false
        });
      });
    }, error => {
      this.openSnackBar("Error in list loading", 'error');
    });
  }

  public loadInvoiceFiles() {
    this.carrierInvoiceFiles.getAll(null).subscribe(result => {
      result.forEach(e => {
        this.carrierInvoices.push({ label: e.label, value: e.id });
      });

    }, error => {
      // this.alert.send(AlertMessage.getOnHttpError("CarrierInvoiceFileGetFail", "Failed to get invoice files", error));
      this.openSnackBar('Failed to get invoice files', 'error');

    });
  }

  public resetForm() {
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new Customerinvoices();
    this.customerInvoices.carrierInvoiceDatasource.next('');
    this.loadListData(this.pageNumber,this.pageSize);
  }

  public showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new Customerinvoices();
    this.customerInvoices.carrierInvoiceDatasource.next('');
  }

  ngDoCheck() {
    if (this.model.clientId) {
      this.disableAddTransaction = false;
    }
    else {
      this.disableAddTransaction = true;

    }
  }

  handlePageTop($event) {
    console.log($event);
  }

  public showNew() {
    this.TransactiondataSource = new MatTableDataSource<any>([]);
    this.TransactiondataSourceMainPage = new MatTableDataSource<any>([]);
    this.customerInvoices.carrierInvoiceDatasource.next('');
    this.mode = FormMode.New;
    this.model.selected = false;
    this.model = new Customerinvoices();
    this.model.status = "Created";
    this.model.invoiceDate = new Date();
    this.model.selected = true;
  }

  public showEdit(row) {
    this.DisableState = row.status == 'Deleted' ? true : false;
    localStorage.setItem("customerInvoiceId", row.id.toString());
    this.mode = FormMode.Edit;
    this.model.selected = false;
    //this.model = row;
    this.model.id = row.id;
    this.model.clientId = row.clientMasterId;
    this.model.invoiceDate = row.invoiceDate;
    this.model.invoiceEndDate = row.invoiceEndDate;
    this.model.invoiceStartDate = row.invoiceStartDate;
    this.model.status = row.status;
    this.model.total = row.total;
    this.model.selected = true;
    this.customerInvoices.carrierInvoiceDatasource.next(this.model);
    this.loadGridDataInEdit(this.model, 'load');
  }

  public showDel(p) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.clientId = p.clientMasterId;
    this.model.selected = true;
    //this.delete();
  }

  generateCustomerInvoice(event, model) {
    if (model.status == "Sent") {
      alert("Invoice is already generated.")
    }
    else {
      let req = {
        Id: model.id,
        ClientId: model.clientId,
        InvoiceDate: model.invoiceDate,
        InvoiceId: 0,
        InvoiceNumber: "",
        Status: model.status,
        Total: model.total,
        invoiceMaxDate: model.invoiceMaxDate ? model.invoiceMaxDate : new Date().toISOString().slice(0, 10),
        invoiceMinDate: model.invoiceMinDate ? model.invoiceEndDate : new Date().toISOString().slice(0, 10)
      }
      this.customerInvoices.generateInvoice(req).subscribe(
        (res) => {
          //debugger;
          //Calling this to update the Invoice status to sent
          console.log(res);
          req.InvoiceId = res.invoiceId;
          req.InvoiceNumber = res.invoiceNumber;
          if (res.status == "InvoiceFailed") {
            this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generated successfully but, failed to create record in Quickbooks", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
          }
          else {
            this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generated successfully and sent to intended recipient", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
          }

        },
        e => {
          this.alert.send(new AlertMessage("CustomerInvoice", "Failed to Generate Customer Invoice. Please verify if the Invoice has Quoated Records", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
          // this.openSnackBar('Failed to Generate Customer Invoice. Please verify if the Invoice has Quoated Records', 'error');
        }
      );
    }
  }

  reGenerateCustomerInvoice(event, model) {
    if (model.status == "Sent") {
      this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation is already completed for this invoice", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
    }
    else {
      let req = {
        Id: model.id,
        ClientId: model.clientId,
        InvoiceDate: model.invoiceDate,
        InvoiceId: 0,
        InvoiceNumber: "",
        Status: model.status,
        Total: model.total,
        invoiceMaxDate: model.invoiceMaxDate ? model.invoiceMaxDate : new Date().toISOString().slice(0, 10),
        invoiceMinDate: model.invoiceMinDate ? model.invoiceEndDate : new Date().toISOString().slice(0, 10)
      }
      this.customerInvoices.reGenerateInvoice(req).subscribe(
        (res) => {
          if (res.isSuccess) {
            var invoiceResponse = JSON.parse(res.results);
            this.DisableState = invoiceResponse.Status == 'Finalized' ? true : false;
            localStorage.setItem("customerInvoiceId", invoiceResponse.Id.toString());
            this.mode = FormMode.Edit;
            this.model.selected = false;
            this.model = invoiceResponse;
            this.model.id = invoiceResponse.Id;
            this.model.clientId = invoiceResponse.ClientMasterId;
            this.model.status = invoiceResponse.Status;
            this.model.invoiceDate = invoiceResponse.InvoiceDate;
            this.model.total = invoiceResponse.Total;
            this.model.invoiceStartDate = invoiceResponse.InvoiceStartDate;
            this.model.invoiceEndDate = invoiceResponse.InvoiceEndDate;
            this.model.selected = true;
            this.customerInvoices.carrierInvoiceDatasource.next(this.model);
            this.loadGridDataAfterFinalized(this.model, 'load');
            this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generated successfully and saved to database.", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Confirm }));

          }
          else {
            if (res.error != null) {
              if (res.error.systemMessage != null) {
                this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation failed with errors " + res.error.systemMessage, AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
              }
              else {
                this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation failed with errors: " + res.error.userMessage, AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
              }
            }
            else {
              this.alert.send(new AlertMessage("CustomerInvoice", "Invoice could not be processed", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
            }
          }
        },
        e => {
          this.alert.send(new AlertMessage("CustomerInvoice", "Failed to Generate Customer Invoice. Please verify if the Invoice has Quoated Records", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
        }
      );
    }
  }

  createAccountingInvoice(event, model) {
    if (model.status == "Sent") {
      this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation is already completed for this invoice", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));

    }
    else {
      let req = {
        Id: model.id,
        ClientId: model.clientId,
        InvoiceDate: model.invoiceDate,
        InvoiceId: model.invoiceId,
        InvoiceNumber: model.invoiceNumber,
        Status: model.status,
        Total: model.total,
        invoiceMaxDate: model.invoiceMaxDate ? model.invoiceMaxDate : new Date().toISOString().slice(0, 10),
        invoiceMinDate: model.invoiceMinDate ? model.invoiceEndDate : new Date().toISOString().slice(0, 10)
      };
      this.customerInvoices.createAccountingInvoice(req).subscribe(
        (res) => {
          if (res.isSuccess) {
            var invoiceResponse = JSON.parse(res.Response);
            this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generated successfully and sent to intended recipient", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
          }
          else {
            if (res.error != null) {
              if (res.error.systemMessage != null) {
                this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation failed with errors: " + res.error.systemMessage, AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
              }
              else {
                this.alert.send(new AlertMessage("CustomerInvoice", "Invoice generation failed with errors: " + res.error.userMessage, AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
              }
            }
            else {
              this.alert.send(new AlertMessage("CustomerInvoice", "Quickbooks Invoice generation failed. Please contact administrator", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
            }

          }
        },
        e => {
          this.alert.send(new AlertMessage("CustomerInvoice", "Failed to Generate Customer Invoice. Please verify if the Invoice has Quoated Records", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
          // this.openSnackBar('Failed to Generate Customer Invoice. Please verify if the Invoice has Quoated Records', 'error');
        }
      );
    }
  }

  verifyAccountingToken(event, model) {
    this.customerInvoices.verifyAccountingToken().subscribe(
      (res) => {
        if (res != "Valid") {
          //Check the below URL in future for proper implementation
          //https://stackoverflow.com/questions/64443623/angular-open-component-in-new-tab-without-bootstrapping-whole-app
          window.open(res, 'newwindow', 'width=600, height=450');
        }
        else {
          this.createAccountingInvoice(event, model);
        }
      },
      e => {
        this.alert.send(new AlertMessage("CustomerInvoice", "Unable to validate Quickbooks token, please generate a token in QBO by authorization or contact administrator", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
      }
    );
  }

  verifyAccountingTokenForFileDownload(rowId) {
    this.customerInvoices.verifyAccountingToken().subscribe(
      (res) => {
        if (res != "Valid") {
          //Check the below URL in future for proper implementation
          //https://stackoverflow.com/questions/64443623/angular-open-component-in-new-tab-without-bootstrapping-whole-app
          window.open(res, 'newwindow', 'width=600, height=450');
        }
        else {
          window.open(this.CarrierInvoiceFileControllerUrl+"?id=" + rowId , '_blank');
        }
      },
      e => {
        this.alert.send(new AlertMessage("CustomerInvoice", "Unable to validate Quickbooks token, please generate a token in QBO by authorization or contact administrator", AlertSeverity.Error, <AlertOptions>{ BoxType: AlertTypes.Confirm }));
      }
    );
  }

  pageChanged(event) {
    if (event.previousPageIndex > event.pageIndex) {
      // previous button clicked
    } else {
      // next button clicked
    }
  }

  openDialog(act) {
    this.selection.clear()
    this.TransactiondataSource.data = [];
    this.MinDate = this.model.invoiceStartDate ? this.model.invoiceStartDate : this.model.invoiceDate;
    this.MaxDate = this.model.invoiceEndDate ? this.model.invoiceEndDate : new Date();
    let dialogRef = this.dialog.open(this.callAddTransacationDialog);
    if (act == 'load') {
      this.Postaction = "load";
      let clientid = this.model.clientId;
      let invoiceStartDate = this.model.invoiceStartDate;
      let invoiceEndDate = this.model.invoiceEndDate;
      let action = act;
      let customerInvoiceId = this.model.id;
      this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId, this.pageNumber, this.pageSize).subscribe((res) => {
        res.forEach(element => {
          element["select"] = true;
        });
        this.data = res.data;
        this.TransactiondataSource.data = res.data;
        this.loadselected = res.data;
        //  this.selection.select(...this.TransactiondataSource.data)
        this.TransactiondataSource.paginator = this.Transactionpaginator;
        this.pageLength = res.totalRecords;
        this.masterToggle();
        console.log(res);
      },
        (err) => {
          console.log(err);
        })

    }
    else {

    }
    console.log(this.model.clientId)
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result !== 'no') {
          const enabled = "Y"
          console.log(result);
        } else if (result === 'no') {
          console.log('User clicked no.');
        }
      }
    })
  }


  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.customerInvoices.carrierInvoiceDatasource.subscribe((res) => {
      if (res) {
        this.Postaction = "load";
        let clientid = res.clientId;
        let invoiceStartDate = res.invoiceStartDate;
        let invoiceEndDate = res.invoiceEndDate;
        let action = "load";
        let customerInvoiceId = res.id;
        this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId, this.pageNumber + 1, this.pageSize).subscribe(
          (res) => {
            this.dataMainPage = res.data;           
            this.TransactiondataSourceMainPage.data = res.data;         
            this.TransactiondataSourceMainPage.paginator = this.TransactionMainPagepaginator;
            this.pageLength= res.totalRecords;
            this.loadGridData.next(false);
          },
          (err) => {
            console.log(err);
          })
      };
      //this.loadGridDataInEdit(JSON.parse(res.toString()), 'load');

    });
  }


  loadGridDataInEdit(p: Customerinvoices, act) {
    this.selection.clear();
    this.TransactiondataSourceMainPage.data = [];
    this.MinDate = p.invoiceStartDate ? p.invoiceStartDate : p.invoiceDate;
    this.MaxDate = p.invoiceEndDate ? p.invoiceEndDate : new Date();
    if (act == 'load') {
      this.Postaction = "load";
      //let clientid = p.clientId;
      let clientid = p.clientId;
      let invoiceStartDate = p.invoiceStartDate;
      let invoiceEndDate = p.invoiceEndDate;
      let action = act;
      let customerInvoiceId = p.id;
      this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId, this.pageNumber,this.pageSize).subscribe(
        (res) => {
          this.dataMainPage = res.data;
          this.TransactiondataSourceMainPage.data = res.data;
          this.TransactiondataSourceMainPage.paginator = this.TransactionMainPagepaginator;
          this.pageLength = res.totalRecords;
          this.loadGridData.next(false);
        },
        (err) => {
          console.log(err);
        })
    }
  }

  public getTransactions(act) {
    let p = []
    this.selection.selected.forEach((element) => {
      p.push({ Id: element.id, Total: element.carrierTotalCharge, MasterTrackingNumber: element.masterTrackingNumber, CustomerPrice: element.customerTotalCharge, ClientId: this.model.clientId, CustomerInvoiceId: this.model.id, NetAmount: element.netAmount, ModifiedNetAmount: element.modifiedNetAmount, Description: element.description });
    });

    let req = {
      Id: this.model.id,
      ClientId: this.model.clientId,
      InvoiceDate: this.model.invoiceDate,
      Status: this.model.status,
      Total: this.model.total,
      MinDate: new Date(this.MinDate).toLocaleDateString(),
      MaxDate: new Date(this.MaxDate).toLocaleDateString(),
      //     let invoiceStartDate = new Date(this.MinDate).toLocaleDateString();
      //  let invoiceEndDate = new Date(this.MaxDate).toLocaleDateString();
      //CarrierInvoiceFileId: 0,
      Action: act,
      CarrierInvoiceShipments: p
    }

    this.customerInvoices.PostTransaction(req).subscribe((res) => {
      console.log(res);
      this.DisableState = res.status == 'Deleted' ? true : false;
      localStorage.setItem("customerInvoiceId", res.id.toString());
      this.mode = FormMode.Edit;
      this.model.selected = false;
      this.model = res;
      this.model.id = res.id;
      this.model.clientId = res.clientMasterId;
      this.model.status = res.status;
      this.model.invoiceDate = res.invoiceDate;
      this.model.total = res.total;
      this.model.invoiceStartDate = res.invoiceStartDate;
      this.model.invoiceEndDate = res.invoiceEndDate;
      this.model.selected = true;
      this.customerInvoices.carrierInvoiceDatasource.next(this.model);
      this.loadGridDataInEdit(this.model, 'load');
      //this.loadGridData.next(true);
      const options = {
        title: 'Succesful',
        message: 'Transaction added successfully',
        cancelText: 'Ok',
        //confirmText: 'Confirm'
      };
      this.close();
      this.snackservice.open(options);
      
      
    },
      (err) => {
        //debugger;
        console.log(err);
        const options = {
          title: 'Failed',
          message: 'Add Transactions failed',
          // message: err,
          cancelText: 'Ok',
          //confirmText: 'Confirm'
        };
        this.snackservice.open(options);

      });

  }

  public pull(act) {
    if (this.isAllSelected()) {
      this.masterToggle();
    }
    let clientid = this.model.clientId;
    let invoiceStartDate = new Date(this.MinDate).toLocaleDateString();
    let invoiceEndDate = new Date(this.MaxDate).toLocaleDateString();
    let action = act;
    //  let customerInvoiceId = this.model.id != null && this.model.id > 0? this.model.id : 0 ;
    let customerInvoiceId = this.model.id ?? 0;
    this.TransactiondataSource.data = [];
    this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId, this.pageNumber, this.pageSize).subscribe((res) => {
      this.data = res.data;
      this.TransactiondataSource.data = res.data;
      this.TransactiondataSource.paginator = this.Transactionpaginator;
      this.pageLength = res.totalRecords;
      this.masterToggle();
    },
      (err) => {
        console.log(err);
      })
  }

  public load() {
    let c = localStorage.getItem('clientId');
    let clientid = this.model.clientId;
    let l1 = new Date(this.MinDate).toLocaleDateString();
    let invoiceStartDate = this.MinDate.toISOString().substring(0, 10);
    let invoiceEndDate = this.MaxDate.toISOString().substring(0, 10);
    let action = "load";
    let customerInvoiceId = this.model.id ?? 0;
    this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId,this.pageNumber, this.pageSize).subscribe((res) => {
      this.data = res.data;
      this.TransactiondataSourceMainPage.data = res.data;
      this.TransactiondataSourceMainPage.paginator = this.TransactionMainPagepaginator;
      this.pageLength = res.totalRecords;
    },
      (err) => {
        console.log(err);
      })

  }

  public closeMappingsModal() {
    this.showTransactionDiag = false;
  }

  openSnackBar(message: string, messageType: 'error' | 'success' | 'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type: messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass = messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

  close() {
    this.dialog.closeAll();
    this.Postaction = 'Pull';
    this.MaxDate = '';
    this.MinDate = '';
    this.dataSource = new MatTableDataSource(this.tabledata);
    // this.TransactiondataSource = new MatTableDataSource<any>([]);
    this.dataSource.paginator = this.paginator;
  }

  loadGridDataAfterFinalized(p, act) {
    this.selection.clear();
    this.TransactiondataSourceMainPage.data = [];
    this.MinDate = p.InvoiceStartDate ? p.InvoiceStartDate : p.InvoiceDate;
    this.MaxDate = p.InvoiceEndDate ? p.InvoiceEndDate : new Date();
    if (act == 'load') {
      this.Postaction = "load";
      let clientid = p.ClientMasterId;
      let invoiceStartDate = p.InvoiceStartDate;
      let invoiceEndDate = p.InvoiceEndDate;
      let action = act;
      let customerInvoiceId = p.Id;
      this.customerInvoices.getTransaction(clientid, invoiceStartDate, invoiceEndDate, action, customerInvoiceId, this.pageNumber, this.pageSize).subscribe(
        (res) => {
          this.dataMainPage = res.data;
          this.TransactiondataSourceMainPage.data = res.data;
          this.TransactiondataSourceMainPage.paginator = this.TransactionMainPagepaginator;
          this.pageLength = res.totalRecords;
          this.loadGridData.next(false);
        },
        (err) => {
          console.log(err);
        })
    }
  }
}
